"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameFieldWithLabel = exports.NameField = void 0;
var React = require("react");
var SelectField_1 = require("./SelectField");
var TextField_1 = require("./TextField");
var core_1 = require("@blueprintjs/core");
var NameField = function (props) { return (React.createElement("div", { id: props.id, className: "".concat(core_1.Classes.CONTROL_GROUP) },
    React.createElement(SelectField_1.SelectField, { id: "name_title", items: ['Mr.', 'Ms.', 'Mrs.', 'S/O', 'D/O', 'B/O', 'F/O', 'M/O', 'W/O', 'Master', ''], value: props.title, onItemSelect: function (item) { return props.setTitle(item.name); } }),
    React.createElement(TextField_1.TextField, { autoFocus: props.autoFocus, id: "name", leftIcon: "person", placeholder: "Name", onChange: props.setName, value: props.name, error: props.error }))); };
exports.NameField = NameField;
var NameFieldWithLabel = function (props) { return (React.createElement(core_1.FormGroup, { inline: props.inline, intent: props.error ? core_1.Intent.DANGER : core_1.Intent.NONE, label: React.createElement("span", { className: "f5 fw5" }, props.label), labelInfo: props.required, helperText: props.error ? props.error : props.helperText, labelFor: props.id },
    React.createElement(exports.NameField, __assign({}, props)))); };
exports.NameFieldWithLabel = NameFieldWithLabel;
//# sourceMappingURL=NameField.js.map